import React, { useContext } from 'react';
import { MainContext } from '../../context/Main.context';
import { Tab } from '../Tab/Tab';
import Loader from "../../assets/icons/loading.gif";
import Confirm from "../../assets/icons/confirm.png";
import { ConfirmationTabBody, ConfirmLabel, LicencePrice, LicencePriceWrapper, LoadingLabel } from './ConfirmationTab.styled';

export const ConfirmationTab = () => {
    const {
        currentFormTab,
        loading,
        licencePrice,
    } = useContext(MainContext);

    return (
        <Tab show={currentFormTab === 7}>
            <ConfirmationTabBody>
                {loading ? (
                    <>
                        <img src={Loader} alt="loader" height="150px" width="150px" />
                        <LoadingLabel>
                            Vos données sont en cours de transmission...
                        </LoadingLabel>
                    </>
                ) : ( 
                    <>
                        <img src={Confirm} alt="confirm" height="150px" width="150px" />
                        <ConfirmLabel>
                            Vos données ont été transmises avec succès !
                        </ConfirmLabel>
                        <LicencePriceWrapper>
                            <div>Vous devrez vous acquitter du règlement de la licence à auteur de</div>
                            <LicencePrice>{licencePrice} €</LicencePrice>
                            <div>Vous pouvez régler par chèque auprès d'un responsable du club</div>
                            <div>Le règlement peut se faire en 4 chèques maximum</div>
                        </LicencePriceWrapper>
                    </>
                )}
            </ConfirmationTabBody>
        </Tab>
    )
}
